module.exports = __webpack_public_path__ + "20250721160708/img/project_manage.2ef1650e.png";